module.exports = __webpack_public_path__ + "img/logo-nav-dark.9008d4a9.webp";